@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if (setCheckInEvent($.row.clt_chkin_event_type) != null) {
    <span
      >{{
        'ADMIN.CHECK_IN.' + setCheckInEvent($.row.clt_chkin_event_type)
          | translate
      }}
    </span>
  } @else {
    -
  }
}
